import { ChargePointSummary, Session } from '../../../../../app/ApiGen';
import { chargePointHasAttributes } from '../../../../../utils/format';
import { Normalised } from '../../../../../utils/request';

export type NormalisedSession = Normalised<Session> & { chargePoint: Normalised<ChargePointSummary> };

export function isNormalisedSessionWithChargePoint(session: Normalised<Session>): session is NormalisedSession {
  return !!session && chargePointHasAttributes(session.chargePoint);
}
